import * as doplnky from "./doplnkove-sluzby-doplnky.js";
import {Top} from "../class/Top.js";

export var opt = {
  provestNakup: false,
  ajaxCartItem: false
};

var $arrDoplnky = [];
var $arrUpgrade = [];
var $arrDalsiDiskAj = [];
var $arrUpgradeWindows = [];

var $arrPrepinace = [];
var $arrSelecty = [];
var $arrAnoNe = [];


export function dopln_vytvor_anoNe(idSelectu, O){
  let neText = O.NeText || 'Ne';
    
  return `
            <label>
              <em class="${idSelectu} pulse">
                <input data-ldz-cena="${O.price}"  data-ldz-cena-no-vat="${O.pricenoVAT}"   type="checkbox" class="doplnekUprade checkSwitch" value="${O.priceID}">
              </em>
              <span>
                <big>Ano</big>
                <small>+ ${Top.formatujMenu(O.price)}</small>
              </span>  
            </label>
            <span class="divider"> | </span>
            <label class="lblEmpty">
              <input type="checkbox"  data-ldz-cena="0"  data-ldz-cena-no-vat="0" class="doplnekUprade checkSwitch" value="">
              <span>${neText}</span>  
            </label>
          
  `;

}

export function dopln_vytvor_radio_buttony(idSelectu, pole, $name) {
  if (!pole.length) return false;

  let res=`<label class="lblEmpty">
            <span>nepotřebuji</span>
            <input data-ldz-cena="0" data-ldz-cena-no-vat="0" class="doplnekUprade" type="radio" name="arrDopl[${idSelectu}]" value="">
           </label>`;

           pole.forEach(function(entry) {
            res += `  <label>
                        <span>
                          <big>${entry.name}</big>
                          <small>+ ${Top.formatujMenu(entry.price)}</small>

                        </span>
                        <input data-ldz-cena="${entry.price}"  data-ldz-cena-no-vat="${entry.pricenoVAT}" title="${$name}" class="doplnekUprade" type="radio" name="arrDopl[${idSelectu}]" value="${ entry.priceID}">
                      </label>`;              
          });

  return res;         

} //function  dopln_vytvor_select(idSelectu,pole) 
export function dopln_vytvor_select(idSelectu, pole, $name) {
  if (!pole.length) return false;


  var $ret = `<select class="doplnekUprade"  id="${idSelectu}">
                <option value=""  data-ldz-cena="0" data-ldz-cena-no-vat="0">${$name}</option>
                <option value=""  data-ldz-cena="0" data-ldz-cena-no-vat="0">Nepotřebuji</option>
                `;

  

  pole.forEach(function(entry) {   
    
    $ret +=`<option data-ldz-cena="${entry.price}" data-ldz-cena-no-vat="${entry.pricenoVAT}" value="${entry.priceID}">${entry.name } + ${Top.formatujMenu(entry.price)}</option>`;

  });

  $ret += '</select>';

  return $ret;
} //function  dopln_vytvor_select(idSelectu,pole)

function nactiDoplnkyUpgrade() {
  $arrUpgrade = [];
  $arrDoplnky = [];
  $arrDalsiDiskAj = [];
  $arrUpgradeWindows = [];
  $arrSelecty = [];
  $arrAnoNe = [];  
  $arrPrepinace=[];

  var $res;
  //----doplnky
  $res = doplnky.doplnek_vymena_ram();
  if ($res){
    $arrUpgrade.push($res);
    $arrPrepinace.push($res);
    Lc.h('---doplnky',$res);

  } 

  Lc.log('----res----',$res);

  $res = doplnky.doplnek_vymena_disku();
  if ($res){
    $arrUpgrade.push($res);
    $arrPrepinace.push($res);
  } 

  $res = doplnky.doplnek_pridani_zaruky();
  if ($res) {
    $arrSelecty.push($res);
  }

  $res = doplnky.doplnek_pridani_baterie();
  if ($res) {
    $arrSelecty.push($res);
  }

  $res = doplnky.doplnek_pridani_rgbkit();
  if ($res) {
    $arrSelecty.push($res);
  }

  $res = doplnky.doplnek_pridani_chlazeni();
  if ($res) {
    $arrSelecty.push($res);
  }

  $res = doplnky.doplnek_pridani_grafiky();
  if ($res){
    $arrUpgrade.push($res);
    $arrSelecty.push($res);
  }  

  $res = doplnky.doplnek_zmena_grafiky();
  if ($res){
    $arrSelecty.push($res);
  }  


  $res = doplnky.doplnek_predinstalace_programu();
  if ($res){
    $arrDoplnky.push($res);
    $arrAnoNe.push($res);
  }  
  $res = doplnky.doplnek_okamzita_vymena();
  if ($res) $arrDoplnky.push($res);

  $res = doplnky.doplnek_pridani_disku();
  if ($res) {
    $arrDalsiDiskAj.push($res);
    Lc.log('doplnek_pridani_disku',$res);
    $arrSelecty.push($res);

    $res = doplnky.doplnek_preinstalace_os();
    if ($res) $arrDalsiDiskAj.push($res);
  }

  $res = doplnky.doplnek_upgrade_windows();
  if ($res) {
    $arrUpgradeWindows.push($res);
  }

 

  /*
    console.log($arrUpgrade);
    console.log($arrDoplnky);
    */
} //function  nactiDoplnkyUpgrade()
function zobrazDoplnkyUpgradeNove(){
  Lc.f('zobrazDoplnkyUpgradeNove');
  //var $html, $tooltipText;
  let diUpgr = $("#dvDoplUpgrN");
  let c;
  if(!$arrPrepinace.length && !$arrSelecty.length && !$arrAnoNe.length){
    return false;
  }else{
    diUpgr.show();
  }
  diUpgr.append('<h2 class="h2c"><em>Když ho chceš vylepšit</em></h2>');
  Lc.log('$arrPrepinace',$arrPrepinace);
  
  let zobrazBlokPrepinacu = function($arrPrepinace){
    if(!$arrPrepinace.length)return '';
    let c;

    let kod='';
    $arrPrepinace.forEach(function(entry) {
      Lc.log('entry',entry);
      c = zobrazPrepinac(entry);
      kod+=c;
      //diUpgr.append(c);
    });
    return `<div class="dvPrep">${kod}</div>`;
  };
  c = zobrazBlokPrepinacu($arrPrepinace);
  diUpgr.append(c);

  let zobrazBlokSelectu = function($arrSelecty){
    if(!$arrSelecty.length)return '';
    let c;

    let kod='';
    $arrSelecty.forEach(function(entry) {
      Lc.log('entry',entry);
      c = zobrazSelect(entry);
      kod+=c;
      //diUpgr.append(c);
    });
    return `<div class="dvSel">${kod}</div>`;
  };
  c = zobrazBlokSelectu($arrSelecty);
  diUpgr.append(c);
  
  
  let zobrazBlokAnoNe = function($arrAnoNe){
    if(!$arrAnoNe.length)return '';
    let c;

    let kod='';
    $arrAnoNe.forEach(function(entry) {
      Lc.log('entry',entry);
      c = zobrazAnoNe(entry);
      kod+=c;
      //diUpgr.append(c);
    });
    return `<div class="dvAnoNe">${kod}</div>`;
  };
  c = zobrazBlokAnoNe($arrAnoNe);
  diUpgr.append(c);



  //---switch napr ano ne
  diUpgr.find(".checkSwitch").change(function() {
    //let emRodic =  $(this).closest('em');
    var rodic = $(this).closest('.dvPol');
    $(this).closest('label').addClass('sel');

    let zaskr = $(this).prop('checked');
    if(zaskr){
      rodic.find(".checkSwitch").not($(this)).attr('checked', false).closest('label').removeClass('sel');
    }else{
      rodic.find(".checkSwitch").attr('checked', false).closest('label').removeClass('sel');
    }

   //Lc.log('zaskr',zaskr),
    
});
//pulsujici ikona pro predinstalaci
diUpgr.find(".predinstalace").each(function() {
   let rodic =  $(this).closest('.dvPol');
   let em = $(this);
   rodic.find(".checkSwitch").change(function() {
      let pocet = rodic.find(".checkSwitch:checked").length;
      if(pocet){
        em.removeClass('pulse');
      }else{
        em.addClass('pulse');
      }

  });

}); 




diUpgr.find(".dvPrep input").change(function() {
  var rodic = $(this).closest('.dvPol');
  $(this).closest('label').addClass('sel');
  rodic.find(".doplnekUprade").not($(this)).closest('label').removeClass('sel');
});

//event pro zmenu ceny
diUpgr.find("input,select").change(function() {
  let ObjCeny = vratCenyVybranychDolnku();
  
  Lc.t('-------event pro zmenu ceny--',[ObjCeny]);
  $(document).trigger("ladzo:cenyDoplnkovychSluzeb", [ObjCeny]);
  
});

$("#dvDoplUpgrN .show-tooltip").tooltip({
  html: true,
  placement: "auto"
});

}//function zobrazDoplnkyUpgradeNove()

/*
function zobrazDoplnkyUpgrade() {
  var $html, $tooltipText;

  if (!$arrDoplnky.length && !$arrUpgrade.length && !$arrDalsiDiskAj.length) {
    $("#dvDoplUpgr").remove();
    return false;
  }
  var $diUpgr = $("#dvDoplUpgr");
  var $div = $('<div class="dvFlx"></div>').appendTo("#dvDoplUpgr");

  if ($arrUpgrade.length) {
    var $divUpgr = $('<div id="dvUpgr"></div>').appendTo($div);

    var $tooltip = "";
    $tooltipText = get(window.sortimentDoplnky, "POPIS.KONFIGURACE") || false;
    if ($tooltipText)
      $tooltip =
        '<strong class="show-tooltip spI" title="" data-original-title="' +
        $tooltipText +
        '"><em>?</em></strong>';

    $divUpgr.append("<h3>Vylepšit konfiguraci" + $tooltip + "</h3>");

    $html = "<table>";

    $arrUpgrade.forEach(function(entry) {
      $html += "<tr><td>" + entry.select + "</td></tr>";
    });

    $html += "</table>";

    $divUpgr.append($html);
  } // if($arrUpgrade.length){

  if ($arrDoplnky.length) {
    var $divDopl = $('<div id="dvDoplnky"></div>').appendTo($div);

    $tooltip = "";
    $tooltipText = get(window.sortimentDoplnky, "POPIS.DOPLNKY") || false;
    if ($tooltipText)
      $tooltip =
        '<strong class="show-tooltip spI" title="" data-original-title="' +
        $tooltipText +
        '"><em>?</em></strong>';

    $divDopl.append("<h3>Může se hodit" + $tooltip + "</h3>");

    $html = "<table>";
    $arrDoplnky.forEach(function(entry) {
      $html += "<tr><td>" + entry.popis + "</td></tr>";
    });

    $html += "</table>";

    $divDopl.append($html);
  } // if($arrDoplnky.length){

  //----pridani dalsiho disku
  if ($arrDalsiDiskAj.length) {
    var $divDsk = $('<div id="dvDalsiDisk"></div>').appendTo($div);

    $html = '<div><div class="dvFlx">';
    $arrDalsiDiskAj.forEach(function(entry) {
      var $jeSelect = fce.has(entry, "select");
      $html += "<div>" + ($jeSelect ? entry.select : entry.popis) + "</div>";
    });
    $html += '</div><!--class="dvFlx"--></div>';

    $divDsk.append($html);
  } // if($arrDalsiDiskAj.length){

  if ($arrUpgradeWindows.length) {
    var $diUpgrWin = $('<div id="dvUpgrWind"></div>').appendTo($diUpgr);
    if ($arrUpgrade.length) $diUpgrWin.addClass("a");

    var $tooltip1 = "";
    $tooltipText =
      get(window.sortimentDoplnky, "POPIS.UPGRADE_WINDOWS") || false;
    if ($tooltipText)
      $tooltip =
        '<strong class="show-tooltip spI" title="" data-original-title="' +
        $tooltip1 +
        '"><em>?</em></strong>';

    $diUpgrWin.append("<h3>Upgrade Windows" + $tooltip1 + "</h3>");

    $html = '<div class="dvFlx"><div><table>';

    $arrUpgradeWindows.forEach(function(entry) {
      $html += "<tr><td>" + entry.select + "</td></tr>";
    });

    $html += "</table></div></div>";
    $diUpgrWin.append($html);
  }

  $diUpgr.append(
    "<p>*vyberte si v roletce nebo zatrhněte a klikněte níže na tlačítko  <em>PŘIDAT DO KOŠÍKU</em></p>"
  );

  $("#dvDoplUpgr .show-tooltip").tooltip({
    html: true,
    placement: "auto"
  });
} //function  zobrazDoplnkyUpgrade()
*/

export function vratCenyVybranychDolnku(){
  var arr = [];
  var arrNoVat=[];
  $("#dvDoplUpgrN .doplnekUprade").each(function() {
    var $t = $(this);
    if ($t.attr("type") == "checkbox" && $t.is(":checked")) {
      //Lc.log('cena',$t.attr('data-ldz-cena'));
      arr.push(parseInt($t.attr('data-ldz-cena')));
      arrNoVat.push(parseInt($t.attr('data-ldz-cena-no-vat')));
    } else if ($t.is("select")) {
      //Lc.log('cena2',$t);
      $t.find('option:checked').each(function() {
        let option = $(this);
        arr.push(parseInt(option.attr('data-ldz-cena')));
        arrNoVat.push(parseInt(option.attr('data-ldz-cena-no-vat')));
      });
    } else if ($t.is(":radio") && $t.is(":checked")) {
      //Lc.log('cena3',$t.attr('data-ldz-cena'));
      arr.push(parseInt($t.attr('data-ldz-cena')));
      arrNoVat.push(parseInt($t.attr('data-ldz-cena-no-vat')));
    }

  });

  let sum = 0;
  arr.forEach(function(entry) {
    sum +=entry;    
  });

  let sumNoVat = 0;
  arrNoVat.forEach(function(entry) {
    sumNoVat +=entry;    
  });

  return {
    arr: arr,
    sum: sum,
    arrNoVat:arrNoVat,
    sumNoVat: sumNoVat,
  };

}

export function dopln_vratVybraneDoplnky() {
  var $arr = [];
  $("#dvDoplUpgr .doplnekUprade,#dvDoplUpgrN .doplnekUprade").each(function() {
    var $t = $(this);
    if ($t.attr("type") == "checkbox" && $t.is(":checked") && $t.val()) {
      $arr.push($t.val());
    } else if ($t.is("select") && $t.val()) {
      $arr.push($t.val());
    } else if ($t.is(":radio") && $t.is(":checked") && $t.val()) {
      $arr.push($t.val());
    }
  });

  return $arr;
} //function  dopln_vratVybraneDoplnky()

export function dopln_odeslatPolozkyAjaxem($pole, $index, $pocet, $cesta) {
  if (!opt.provestNakup) return false;

  var $idCeny = $pole[$index];
  var $pocetKusu = $('form#product-detail-form input[name="amount"]').val();

  $.post("/action/Cart/addCartItem/?simple_ajax_cart=1", {
    priceId: $idCeny,
    amount: $pocetKusu
  }).done(function(data) {
    Lc.ajx("data", data);
    if ($index + 1 == $pocet) {
      //console.log('--data--');
      //console.log(data);

      opt.provestNakup = false;

      if ($cesta) window.location.href = $cesta;

      window.hideSpinner();

      var payload = data.payload;

      //window.getCartContent(true);
      //shoptet.cart.getCartContent(true, false);
      // var obj = JSON.parse(data);
      //debugger;
      var count = payload.count;
      var price = payload.price;
      shoptet.cart.updateCartButton(count, price);

      delete shoptet.events.cartLoaded;

      //odeslatFormular();
    } else dopln_odeslatPolozkyAjaxem($pole, $index + 1, $pocet, $cesta);
  }); //$.post
} //function dopln_odeslatPolozkyAjaxem($pole,$index,$pocet){


/*
zobrazí html pro jeden ano ne
*/
function zobrazAnoNe(O){

  Lc.f('zobrazAnoNe');
  Lc.log(O);

  let a ='';
  if(O.url || false){
    let b = O.linkText || 'více';
    a = `<a href="${O.url}" rel="modal:open">${b}</a>`; 
  }

  return `<div class="dvANe">

            <div class="leva">
              <H3 class="${O.idPrvku}"><strong>${O.name}</strong></h3>
              ${a}
            </div>
            <div class="dvPol">
                ${O.anoNe}
              </div>
            </div>`;

}

/*
zobrazí html pro jeden select
*/
function zobrazSelect(O){

  Lc.f('zobrazSelect');
  Lc.log(O);

  let obr = O.obr || false;
  let cls = obr ? 'obrI ':'';
  let a ='';
  if(O.url || false){
    a = `<a href="${O.url}" rel="modal:open">?</a>`; 
  }

  Lc.log('Top',Top);
  if(obr){
    let bcg = 'url("' + Top.httpShoptetUpload + obr + '")';
    Lc.log('bcg',bcg);
    $("body")
      .get(0)
      .style.setProperty("--ldz-image-"+O.idPrvku, bcg);

  }
  return `<div class="dvSi">
            
            <div class="leva">
              <H3 class="${cls}${O.idPrvku}"><strong>${O.popis}</strong>${a}</h3>
            </div>
            <div class="dvPol">
                ${O.select}
              </div>
            </div>`;

}
/*
  zobrazí html pro jeden přepinac
*/
function zobrazPrepinac(O){
  Lc.f('zobrazPrepinac');
  Lc.log(O);
  
  let a ='';
  if(O.url || false){
    let b = O.linkText || 'více';
    a = '<strong> | </strong>' + `<a href="${O.url}" rel="modal:open">${b}</a>`; 
  }
  
  return `<H3><strong>${O.popis}</strong>${a}</h3>
          <div class="dvPol">
            ${O.radioButtony}
          </div>`;
}



export function dopln_ulozitDoplnkyDoKosikuPrejitDoKosiku() {
  opt.ajaxCartItem = true;
  opt.provestNakup = true;
} //function  dopln_ulozitDoplnkyDoKosikuPrejitDoKosiku()

export function zpracujDoplnkoveSluzbyUpgrade() {
  nactiDoplnkyUpgrade();
  zobrazDoplnkyUpgradeNove();
  //zobrazDoplnkyUpgrade();  
} //function  zpracujDoplnkoveSluzbyUpgrade()
